import React, { useRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import qs from "qs";
import ApiUser from "../../../API/ApiUser";

import ApiEnigma from "../../../API/ApiEnigma";
import { getSizeInMb } from "../../../utils/sizeInMb";
import styles from "./newEnigmaStyles";
import NewEnigmaView from "./newEnigmaView";
import ImageUtils from "../../../utils/imageUtils";
import ApiZone from "../../../API/ApiZone";
import { EnigmaType } from "../../../constants/TourConstants";
import ApiTour from "../../../API/ApiTour";
import { withTranslation } from "react-i18next";

class NewEnigma extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      endOfPageRef: React.createRef(),
      isAdmin: false,
      role: null,
      tourDisabled: null,
      enigmaLoaded: false,
      editing: false,
      unsavedChanges: false,
      showError: false,
      errorMessage: "",
      showSuccess: false,
      successMessage: "",
      showSkeletonEnigma: true,
      dialogWaringOpened: false,
      loadingViewOpened: false,
      showVintageImageTooBig: false,
      showArRecognitionImageTooBig: false,
      showClueImageTooBig: false,
      showVideoTooBig: false,
      tourIdToDelete: -1,
      mapDialogOpen: false,
      showLatOnMap: null,
      showLngOnMap: null,
      currenZone: null,
      zoneLng: null,
      zoneLat: null,
      zoneRadius: null,
      selectedTab: "1",
      selectedTabClue: "1",
      tutorialSteps: null,
      openAIModal: false,
      openAIImageModal: false,
      generateImage: false,
      textPrompt: null,
      imagePrompt: null,
      formDatas: {
        tourId: null,
        zoneId: null,
        zoneMode: null,
        enigmaId: -1,
        mediaType: "none",
        type: EnigmaType.TEXT,
        responseType: "text",
        enigmaText: "",
        responsesPicker: [""],
        responsesTextStr: "",
        responsesPickerStr: "",
        compass: 0,
        switchLabels: [""],
        switchValues: [false],
        switchLen: 0,
        multipleChoiceLabels: ["", ""],
        multipleChoiceValues: [false, false],
        recomposeWordTarget: "",
        recomposeRandomLettersEnabled: false,
        recomposeRandomLettersCount: 0,
        potentiometerLabels: [""],
        potentiometerValues: [0],
        potentiometerLen: 0,
        points: 25,
        pickerChoices: [],
        picker: null,
        title: "",
        finishText: "",
        youtubeVideoUrl: null,
        video: {
          file: null,
          url: null,
          fileName: null,
          fileDeleted: false,
        },
        showFinishTextOnLoose: true,
        testCode: null,
        clue: {
          title: "",
          timer: 2,
          imageFile: null,
          imageUrl: null,
          imageDeleted: false,
        },
        vintage: {
          title: "",
          imageFile: null,
          imageUrl: null,
          imageDeleted: false,
        },
        arImageRecognition: {
          title: "",
          imageFile: null,
          imageUrl: null,
          imageDeleted: false,
        },
        arObject: {
          file: null,
          fileUrl: null,
          arObjectDeleted: false,
          arImageRecognitionDeleted: false,
        },
        coordsLongitudeArObject: 0,
        coordsLatitudeArObject: 0,
        teamPhotoFilter: {
          imageFile: null,
          imageUrl: null,
          fileDeleted: false,
          fileName: null,
        },
        sendPhotoWhenGameEnded: false,
        quizMode: false,
      },
      loading: false,
    };

    this.submitForm = this.submitForm.bind(this);

    this.setSelectedTab = this.setSelectedTab.bind(this);
    this.setSelectedTabClue = this.setSelectedTabClue.bind(this);
    this.vintageImageSelected = this.vintageImageSelected.bind(this);
    this.clueImageSelected = this.clueImageSelected.bind(this);
    this.handleSelectResponseTypeChange =
      this.handleSelectResponseTypeChange.bind(this);
    this.handleSelectMediaTypeChange =
      this.handleSelectMediaTypeChange.bind(this);
    this.videoSelected = this.videoSelected.bind(this);
    this.deleteVideo = this.deleteVideo.bind(this);
    this.handleResponsesPickerTextChange =
      this.handleResponsesPickerTextChange.bind(this);
    this.handleResponsesCompassChange =
      this.handleResponsesCompassChange.bind(this);
    this.handleSwitchLabelChange = this.handleSwitchLabelChange.bind(this);
    this.handleSwitchValueChange = this.handleSwitchValueChange.bind(this);
    this.addSwitch = this.addSwitch.bind(this);
    this.addMultipleChoice = this.addMultipleChoice.bind(this);
    this.handleMultipleChoiceLabelChange =
      this.handleMultipleChoiceLabelChange.bind(this);
    this.handleMultipleChoiceValueChange =
      this.handleMultipleChoiceValueChange.bind(this);
    this.removeMultipleChoice = this.removeMultipleChoice.bind(this);
    this.updateRecomposeWordTarget = this.updateRecomposeWordTarget.bind(this);
    this.updateRecomposeRandomLettersEnabled =
      this.updateRecomposeRandomLettersEnabled.bind(this);
    this.updateRecomposeRandomLettersCount =
      this.updateRecomposeRandomLettersCount.bind(this);
    this.removeSwitch = this.removeSwitch.bind(this);
    this.handlePotentiometerLabelChange =
      this.handlePotentiometerLabelChange.bind(this);
    this.handlePotentiometerValueChange =
      this.handlePotentiometerValueChange.bind(this);
    this.addPotentiometer = this.addPotentiometer.bind(this);
    this.removePotentiometer = this.removePotentiometer.bind(this);
    this.updatePoints = this.updatePoints.bind(this);
    this.getPickerChoiceValue = this.getPickerChoiceValue.bind(this);
    this.updatePickerChoice = this.updatePickerChoice.bind(this);
    this.updateTitle = this.updateTitle.bind(this);
    this.updateEnigmaText = this.updateEnigmaText.bind(this);
    this.updateResponsesText = this.updateResponsesText.bind(this);
    this.updateYoutubeVideoUrl = this.updateYoutubeVideoUrl.bind(this);
    this.updateClueTitle = this.updateClueTitle.bind(this);
    this.updateClueTime = this.updateClueTime.bind(this);
    this.updateVintageTitle = this.updateVintageTitle.bind(this);
    this.getPickerChoiceValue = this.getPickerChoiceValue.bind(this);
    this.updateFinishText = this.updateFinishText.bind(this);
    this.updateShowFinishOnLoose = this.updateShowFinishOnLoose.bind(this);
    this.deleteImage = this.deleteImage.bind(this);
    this.openMapDialog = this.openMapDialog.bind(this);
    this.closeMapDialog = this.closeMapDialog.bind(this);
    this.setArObjectLocation = this.setArObjectLocation.bind(this);
    this.deleteObjFile = this.deleteObjFile.bind(this);
    this.arObjectSelected = this.arObjectSelected.bind(this);
    this.updateArCoordsLongitude = this.updateArCoordsLongitude.bind(this);
    this.updateArCoordsLatitude = this.updateArCoordsLatitude.bind(this);
    this.hasOtherMediaThanYT = this.hasOtherMediaThanYT.bind(this);
    this.arImageRecognitionSelected =
      this.arImageRecognitionSelected.bind(this);
    this.resetErrorAlert = this.resetErrorAlert.bind(this);
    this.resetSuccessAlert = this.resetSuccessAlert.bind(this);
    this.handleGenerateEnigma = this.handleGenerateEnigma.bind(this);
    this.handleOpenAIModal = this.handleOpenAIModal.bind(this);
    this.handleCloseAIModal = this.handleCloseAIModal.bind(this);
    this.handleOpenAIImageModal = this.handleOpenAIImageModal.bind(this);
    this.handleCloseAIImageModal = this.handleCloseAIImageModal.bind(this);
    this.handleGenerateImageChange = this.handleGenerateImageChange.bind(this);
    this.handlePromptChange = this.handlePromptChange.bind(this);
    this.handleImagePromptChange = this.handleImagePromptChange.bind(this);
    this.handleGenerateAIImage = this.handleGenerateAIImage.bind(this);
    this.updateTeamPhotoFilter = this.updateTeamPhotoFilter.bind(this);
    this.updateSendPhotoWhenGameEnded =
      this.updateSendPhotoWhenGameEnded.bind(this);
    this.updateQuizMode = this.updateQuizMode.bind(this);
  }

  componentDidMount() {
    const { t } = this.props;
    window.addEventListener("beforeunload", this.handleBeforeUnload);

    document.title = t("newEnigma.page_title");

    this.getAccount();

    let tourId = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).tourId;
    let zoneId = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).zoneId;
    let enigmaId = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).enigmaId;

    let tourIdInt = parseInt(tourId);
    let zoneIdInt = parseInt(zoneId);
    let enigmaIdInt = parseInt(enigmaId);

    this.getFirstTestCode(tourIdInt);

    this.getTourDisableState(tourIdInt);

    if (!tourIdInt || !zoneIdInt) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newEnigma.error_missing_zone_data"),
        showSuccess: false,
      }));

      return;
    }

    this.setState((prevState) => ({
      ...prevState,
      formDatas: {
        ...prevState.formDatas,
        tourId: tourIdInt,
        zoneId: zoneIdInt,
      },
    }));

    if (!zoneIdInt) {
      this.setState((prevState) => ({
        ...prevState,
        showSkeletonEnigma: false,
      }));
      return;
    }
    ApiZone.getZone(tourIdInt, zoneIdInt).then((zoneDatas) => {
      if (!zoneDatas || zoneDatas.status !== 200) {
        return;
      }
      this.setState((prevState) => ({
        ...prevState,
        currentZone: zoneDatas,
        zoneRadius: zoneDatas.data.zoneRadius,
        zoneLat: zoneDatas.data.coordsLatitude,
        zoneLng: zoneDatas.data.coordsLongitude,
        formDatas: {
          ...prevState.formDatas,
          zoneMode: zoneDatas.data.zoneMode,
        },
      }));
    });

    if (!enigmaIdInt) {
      this.setState((prevState) => ({
        ...prevState,
        showSkeletonEnigma: false,
      }));
      return;
    }

    this.setStateIsAdmin();

    ApiEnigma.getEnigma(enigmaId).then((enigmaDatas) => {
      if (!enigmaDatas || enigmaDatas.status !== 200) {
        this.setState((prevState) => ({
          ...prevState,
          showError: true,
          errorMessage: t("newEnigma.error_server_communication"),
          showSuccess: false,
        }));

        return;
      }
      console.log("enigmaDatas", enigmaDatas.data);
      this.setForm(enigmaDatas.data);
    });
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  }

  async getFirstTestCode(tourId) {
    const res = await ApiTour.getFirstTestCode(tourId);
    this.setState((prevState) => ({
      ...prevState,
      testCode: res.data?.code,
    }));
  }

  setSelectedTab = (value) => {
    this.setState((prevState) => ({
      ...prevState,
      selectedTab: value,
    }));
  };

  setSelectedTabClue = (value) => {
    this.setState((prevState) => ({
      ...prevState,
      selectedTabClue: value,
    }));
  };

  async getAccount() {
    let response = await ApiUser.getAccount();

    if (response.status == 200) {
      this.setState((prevState) => ({
        ...prevState,
        role: response.data.role,
        tutorialSteps: response.data.tutorialSteps,
        aiCredits:
          response.data.aiCredits.onAccountCreation +
          response.data.aiCredits.monthlySubscription +
          response.data.aiCredits.paid,
      }));
    }
  }

  async getTourDisableState(tourId) {
    let response = await ApiTour.getTour(tourId);

    if (response.status == 200) {
      this.setState((prevState) => ({
        ...prevState,
        tourDisabled: response.data.disabled,
      }));
    }
  }

  handleBeforeUnload = (event) => {
    const { t } = this.props;
    if (this.state.unsavedChanges) {
      const message = t("newEnigma.modificationsNonEnregistrees");
      event.returnValue = message;
      return message;
    }
  };

  updateArCoordsLongitude(event) {
    event.preventDefault();
    const { t } = this.props;

    if (
      this.state.formDatas.vintage.imageFile ||
      this.state.formDatas.vintage.imageUrl ||
      this.state.formDatas.youtubeVideoUrl
    ) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newEnigma.error_one_media_only"),
        showSuccess: false,
      }));
      this.state.endOfPageRef.current.scrollIntoView({ behavior: "smooth" });
      return;
    }

    let value = event.target.value;

    if (isNaN(parseFloat(value))) {
      value = 0;
    } else {
      value = parseFloat(value);
    }
    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,

      formDatas: {
        ...prevState.formDatas,
        coordsLongitudeArObject: value,
      },
    }));
  }

  updateArCoordsLatitude(event) {
    event.preventDefault();
    const { t } = this.props;

    if (
      this.state.formDatas.vintage.imageFile ||
      this.state.formDatas.vintage.imageUrl ||
      this.state.formDatas.youtubeVideoUrl
    ) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newEnigma.error_one_media_only"),
        showSuccess: false,
      }));
      this.state.endOfPageRef.current.scrollIntoView({ behavior: "smooth" });
      return;
    }

    let value = event.target.value;

    if (isNaN(parseFloat(value))) {
      value = 0;
    } else {
      value = parseFloat(value);
    }

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,

      formDatas: {
        ...prevState.formDatas,
        coordsLatitudeArObject: value,
      },
    }));
  }

  async setArObjectLocation(location) {
    if (!location || !location.lat || !location.lng) return;
    const { t } = this.props;

    if (
      this.state.formDatas.vintage.imageFile ||
      this.state.formDatas.vintage.imageUrl ||
      this.state.formDatas.youtubeVideoUrl
    ) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newEnigma.error_one_media_only"),
        showSuccess: false,
      }));
      this.state.endOfPageRef.current.scrollIntoView({ behavior: "smooth" });
      return;
    }

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,

      formDatas: {
        ...prevState.formDatas,
        coordsLongitudeArObject: location.lng,
        coordsLatitudeArObject: location.lat,
      },
    }));
  }

  closeMapDialog() {
    this.setState((prevState) => ({
      ...prevState,
      mapDialogOpen: false,
    }));
  }

  openMapDialog() {
    let lat = this.state.formDatas.coordsLatitudeArObject;
    let lng = this.state.formDatas.coordsLongitudeArObject;

    this.setState(
      (prevState) => ({
        ...prevState,

        mapDialogOpen: true,
        showLatOnMap: lat,
        showLngOnMap: lng,
      }),
      () => { }
    );
  }

  async setStateIsAdmin() {
    let response = await ApiUser.isAdmin();

    if (response.status == 200) {
      this.setState((prevState) => ({
        ...prevState,
        isAdmin: response.data.isAdmin,
      }));
    }
  }

  setForm(enigmaDatas) {
    let pickerChoices = [];

    for (let choice of enigmaDatas.picker) {
      pickerChoices.push(JSON.parse(choice));
    }
    this.setState((prevState) => {
      const newState = {
        ...prevState,
        editing: true,
        enigmaLoaded: true,
        showSkeletonEnigma: false,
        formDatas: {
          ...prevState.formDatas,
          enigmaId: enigmaDatas.id,
          zoneId: enigmaDatas.ZoneId,
          responseType: enigmaDatas.responseType,
          points: enigmaDatas.points,
          enigmaText: enigmaDatas.enigmaText || "",
          responsesPicker:
            enigmaDatas.responseType == "picker"
              ? enigmaDatas.responses.split(";")
              : [""],
          responsesTextStr:
            enigmaDatas.responseType == "text" ? enigmaDatas.responses : "",
          responsesPickerStr:
            enigmaDatas.responseType == "picker" ? enigmaDatas.responses : "",
          compass:
            enigmaDatas.responseType == "compass" ? enigmaDatas.compass : null,
          switchLabels:
            enigmaDatas.responseType == "switch"
              ? enigmaDatas.switchLabels
                ? enigmaDatas.switchLabels
                : [""]
              : [""],
          switchValues:
            enigmaDatas.responseType == "switch"
              ? enigmaDatas.switchValues
                ? enigmaDatas.switchValues
                : [false]
              : [false],

          multipleChoiceLabels:
            enigmaDatas.responseType == "multipleChoice"
              ? enigmaDatas.multipleChoiceLabels?.length >= 2
                ? enigmaDatas.multipleChoiceLabels
                : ["", ""]
              : ["", ""],
          multipleChoiceValues:
            enigmaDatas.responseType == "multipleChoice"
              ? enigmaDatas.multipleChoiceValues?.length >= 2
                ? enigmaDatas.multipleChoiceValues
                : [false, false]
              : [false, false],

          recomposeWordTarget:
            enigmaDatas.responseType == "recomposeWord"
              ? (enigmaDatas.recomposeWordTarget || "").toString()
              : "",
          recomposeRandomLettersCount:
            enigmaDatas.responseType == "recomposeWord"
              ? typeof enigmaDatas.recomposeRandomLettersCount === "number"
                ? enigmaDatas.recomposeRandomLettersCount
                : 0
              : 0,
          recomposeRandomLettersEnabled:
            enigmaDatas.responseType == "recomposeWord"
              ? enigmaDatas.recomposeRandomLettersCount > 0
              : false,
          potentiometerLabels:
            enigmaDatas.responseType == "potentiometer"
              ? enigmaDatas.potentiometerLabels
                ? enigmaDatas.potentiometerLabels
                : [""]
              : [""],
          potentiometerValues:
            enigmaDatas.responseType == "potentiometer"
              ? enigmaDatas.potentiometerValues
                ? enigmaDatas.potentiometerValues
                : [0]
              : [0],

          type: enigmaDatas.type,
          pickerChoices: pickerChoices,
          picker: null,
          title: enigmaDatas.title,
          finishText: enigmaDatas.finishText,
          showFinishTextOnLoose: enigmaDatas.showFinishTextOnLoose,
          youtubeVideoUrl: enigmaDatas.youtubeVideoUrl,
          video: {
            file: null,
            url:
              enigmaDatas.videoFile?.signedUrl ||
              enigmaDatas.videoFile?.url ||
              enigmaDatas.video?.signedUrl ||
              enigmaDatas.video?.url ||
              null,
            fileName:
              enigmaDatas.videoFile?.name || enigmaDatas.video?.name || null,
            fileDeleted: false,
          },
          coordsLongitudeArObject: enigmaDatas.coordsLongitudeArObject,
          coordsLatitudeArObject: enigmaDatas.coordsLatitudeArObject,
          clue: {
            title: enigmaDatas.clueTitle,
            timer: enigmaDatas.clueTimer,
            imageFile: null,
            imageUrl: enigmaDatas.clueImage?.signedUrl,
          },
          vintage: {
            title: enigmaDatas.vintageTitle,
            imageFile: null,
            imageUrl: enigmaDatas.vintageImage?.signedUrl,
          },
          arObject: {
            file: null,
            fileUrl: enigmaDatas.arObject?.signedUrl,
            fileName: enigmaDatas.arObject?.name,
          },
          arImageRecognition: {
            file: null,
            imageUrl: enigmaDatas.arImageRecognition?.signedUrl,
            fileName: enigmaDatas.arImageRecognition?.name,
          },
          teamPhotoFilter: {
            imageFile: null,
            imageUrl: enigmaDatas.teamPhotoFilter?.signedUrl,
            fileName: enigmaDatas.teamPhotoFilter?.name,
            fileDeleted: false,
          },
          sendPhotoWhenGameEnded: enigmaDatas.sendPhotoWhenGameEnded || false,
          quizMode: enigmaDatas.quizMode || false,
          mediaType: enigmaDatas.vintageImage
            ? "image"
            : enigmaDatas.videoFile || enigmaDatas.video
              ? "video"
              : enigmaDatas.youtubeVideoUrl
                ? "youtube"
                : enigmaDatas.arObject
                  ? "ar"
                  : "none",
        },
      };

      return newState;
    });
  }

  getPickerChoiceValue(event, i) {
    event.preventDefault();

    if (this.state.formDatas.pickerChoices.lenght > i)
      return this.state.formDatas.pickerChoices[i].value;

    return "";
  }

  updateFinishText(event) {
    event.preventDefault();

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        finishText: event.target.value,
      },
    }));
  }

  hasOtherMediaThanYT() {
    if (
      this.state.formDatas.vintage.imageFile ||
      this.state.formDatas.vintage.imageUrl ||
      this.state.formDatas.coordsLongitudeArObject ||
      this.state.formDatas.coordsLatitudeArObject ||
      this.state.formDatas.arImageRecognition.imageFile ||
      this.state.formDatas.arImageRecognition.imageUrl ||
      this.state.formDatas.arObject.file ||
      this.state.formDatas.arObject.fileUrl ||
      this.state.formDatas.video?.file ||
      this.state.formDatas.video?.url
    ) {
      return true;
    }
    return false;
  }

  videoSelected(event) {
    event.preventDefault();
    const { t } = this.props;
    const file = event.target?.files?.[0];
    if (!file) return;

    const fileSizeMb = getSizeInMb(file.size);
    if (fileSizeMb > 300) {
      this.setState((prevState) => ({
        ...prevState,
        showVideoTooBig: true,
      }));
      return;
    }

    if (
      this.state.formDatas.vintage.imageFile ||
      this.state.formDatas.vintage.imageUrl ||
      this.state.formDatas.coordsLongitudeArObject ||
      this.state.formDatas.coordsLatitudeArObject ||
      this.state.formDatas.arImageRecognition.imageFile ||
      this.state.formDatas.arImageRecognition.imageUrl ||
      this.state.formDatas.arObject.file ||
      this.state.formDatas.arObject.fileUrl ||
      this.state.formDatas.youtubeVideoUrl
    ) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newEnigma.error_one_media_only"),
        showSuccess: false,
      }));
      this.state.endOfPageRef.current.scrollIntoView({ behavior: "smooth" });
      return;
    }

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      showError: false,
      showVideoTooBig: false,
      formDatas: {
        ...prevState.formDatas,
        mediaType: "video",
        video: {
          file,
          url: prevState.formDatas.video?.url || null,
          fileName: file.name,
          fileDeleted: false,
        },
      },
    }));
  }

  deleteVideo() {
    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        video: {
          file: null,
          url: null,
          fileName: null,
          fileDeleted:
            !!prevState.formDatas.video?.url || !!prevState.formDatas.video?.file,
        },
      },
    }));
  }

  updateYoutubeVideoUrl(event) {
    event.preventDefault();
    const { t } = this.props;

    if (
      this.state.formDatas.vintage.imageFile ||
      this.state.formDatas.vintage.imageUrl ||
      this.state.formDatas.coordsLongitudeArObject ||
      this.state.formDatas.coordsLatitudeArObject ||
      this.state.formDatas.arImageRecognition.imageFile ||
      this.state.formDatas.arImageRecognition.imageUrl ||
      this.state.formDatas.arObject.file ||
      this.state.formDatas.arObject.fileUrl
    ) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newEnigma.error_one_media_only"),
        showSuccess: false,
        formDatas: {
          ...prevState.formDatas,
          youtubeVideoUrl: null,
        },
      }));
      this.state.endOfPageRef.current.scrollIntoView({ behavior: "smooth" });
      return;
    }

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        youtubeVideoUrl: event.target.value,
        showError: false,
      },
    }));
  }

  updateShowFinishOnLoose(event) {
    event.preventDefault();

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        showFinishTextOnLoose: event.target.value,
      },
    }));
  }

  updatePoints(event, value) {
    event.preventDefault();

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        points: parseInt(event.target.value),
      },
    }));
  }

  updateVintageTitle(event) {
    event.preventDefault();

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        vintage: {
          ...prevState.formDatas.vintage,
          title: event.target.value,
        },
      },
    }));
  }

  updateTitle(event) {
    event.preventDefault();

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        title: event.target.value,
      },
    }));
  }

  updateEnigmaText(event) {
    event.preventDefault();

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        enigmaText: event.target.value,
      },
    }));
  }

  updateClueTitle(event) {
    event.preventDefault();

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        clue: {
          ...prevState.formDatas.clue,
          title: event.target.value,
        },
      },
    }));
  }

  updateClueTime(event, value) {
    event.preventDefault();

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        clue: {
          ...prevState.formDatas.clue,
          timer: parseInt(value),
        },
      },
    }));
  }

  updatePickerChoice(event, index) {
    event?.preventDefault ? event.preventDefault() : null;

    var choices = this.state.formDatas.pickerChoices;
    var choiceExist = false;

    if (this.state.formDatas.pickerChoices) {
      this.state.formDatas.pickerChoices.forEach((choice, i) => {
        if (choice.id == event.target.id) {
          choices[i].value = event.target.value;
          choiceExist = true;
        }
      });
    } else {
      choices = [{ id: event.target.id, value: event.target.value }];
    }

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        pickerChoices: choices,
      },
    }));
  }

  handleResponsesPickerTextChange(event, callback) {
    if (event.target == null) {
      return;
    }

    // Parse les réponses (colonnes)
    let responsesTab = event.target.value?.split(";");

    // Si pas de réponses, on return
    if (responsesTab == null) return;

    // Récupère les choix existants
    let currentChoices = this.state.formDatas.pickerChoices || [];
    let responses = [];
    let newChoices = [];

    // Ajoute les réponses de chaque colonne dans un tableau
    // Pour chaque réponse, ajoute une liste de choix (string avec ;) initialisée à ""
    for (let [index, elem] of responsesTab.entries()) {
      let pickerId = `picker-response-${index.toString()}`;
      responses.push(elem);

      // Cherche un choix existant pour cet index, sinon en crée un nouveau
      let existingChoice = currentChoices.find(
        (choice) => choice.id === pickerId
      );
      newChoices.push(existingChoice || { id: pickerId, value: "" });
    }
    // On ajoute dans le state les réponses et les choix mis à jour
    this.setState(
      (prevState) => ({
        ...prevState,
        unsavedChanges: true,
        formDatas: {
          ...prevState.formDatas,
          responsesPicker: responses,
          responsesPickerStr: event.target.value,
          pickerChoices: newChoices,
        },
      }),
      () => {
        callback ? callback() : null;
      }
    );
  }

  updateResponsesText(event) {
    event.preventDefault();

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        responsesTextStr: event.target.value,
      },
    }));
  }

  handleResponsesCompassChange(event) {
    event.preventDefault();

    if (event.target.value >= 0 && event.target.value <= 360) {
      this.setState((prevState) => ({
        ...prevState,
        unsavedChanges: true,
        formDatas: {
          ...prevState.formDatas,
          compass: event.target.value,
        },
      }));
    }
  }

  handleSwitchLabelChange(event, i) {
    event.preventDefault();
    const newSwitchLabels = [...this.state.formDatas.switchLabels];
    if (i < newSwitchLabels.length) {
      newSwitchLabels[i] = event.target.value;
      this.setState((prevState) => ({
        ...prevState,
        unsavedChanges: true,
        formDatas: {
          ...prevState.formDatas,
          switchLabels: newSwitchLabels,
        },
      }));
    }
  }

  handleSwitchValueChange(event, i) {
    const newSwitchValues = [...this.state.formDatas.switchValues];
    if (i < newSwitchValues.length) {
      newSwitchValues[i] = !newSwitchValues[i];
      this.setState((prevState) => ({
        ...prevState,
        unsavedChanges: true,
        formDatas: {
          ...prevState.formDatas,
          switchValues: newSwitchValues,
        },
      }));
    }
  }

  handleMultipleChoiceLabelChange(event, i) {
    event.preventDefault();
    const newMultipleChoiceLabels = [
      ...this.state.formDatas.multipleChoiceLabels,
    ];
    if (i < newMultipleChoiceLabels.length) {
      newMultipleChoiceLabels[i] = event.target.value;
      this.setState((prevState) => ({
        ...prevState,
        unsavedChanges: true,
        formDatas: {
          ...prevState.formDatas,
          multipleChoiceLabels: newMultipleChoiceLabels,
        },
      }));
    }
  }

  handleMultipleChoiceValueChange(event, i) {
    const newMultipleChoiceValues = [
      ...this.state.formDatas.multipleChoiceValues,
    ];
    if (i < newMultipleChoiceValues.length) {
      newMultipleChoiceValues[i] = !newMultipleChoiceValues[i];
      this.setState((prevState) => ({
        ...prevState,
        unsavedChanges: true,
        formDatas: {
          ...prevState.formDatas,
          multipleChoiceValues: newMultipleChoiceValues,
        },
      }));
    }
  }

  addSwitch(event, i) {
    event.preventDefault();
    const newSwitchLabels = [...this.state.formDatas.switchLabels];
    newSwitchLabels.push("");
    const newSwitchValues = [...this.state.formDatas.switchValues];
    newSwitchValues.push(false);
    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        switchValues: newSwitchValues,
        switchLabels: newSwitchLabels,
      },
    }));
  }

  addMultipleChoice(event, i) {
    event.preventDefault();

    const maxChoices = 6;
    const currentLabels =
      this.state.formDatas.multipleChoiceLabels || [];
    const currentValues =
      this.state.formDatas.multipleChoiceValues || [];

    if (currentLabels.length >= maxChoices) return;

    const newMultipleChoiceLabels = [...currentLabels, ""];
    const newMultipleChoiceValues = [
      ...currentValues,
      false, // Default unchecked value for the new choice
    ];

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        multipleChoiceValues: newMultipleChoiceValues,
        multipleChoiceLabels: newMultipleChoiceLabels,
      },
    }));
  }

  removeSwitch(event, i) {
    event.preventDefault();

    if (i) {
      const newSwitchLabels = [...this.state.formDatas.switchLabels];
      newSwitchLabels.splice(i, 1);
      const newSwitchValues = [...this.state.formDatas.switchValues];
      newSwitchValues.splice(i, 1);
      this.setState((prevState) => ({
        ...prevState,
        unsavedChanges: true,
        formDatas: {
          ...prevState.formDatas,
          switchValues: newSwitchValues,
          switchLabels: newSwitchLabels,
        },
      }));
    }
  }

  removeMultipleChoice(event, i) {
    event.preventDefault();

    const minChoices = 2;
    if (i && this.state.formDatas.multipleChoiceLabels?.length > minChoices) {
      const newMultipleChoiceLabels = [
        ...this.state.formDatas.multipleChoiceLabels,
      ];
      const newMultipleChoiceValues = [
        ...this.state.formDatas.multipleChoiceValues,
      ];

      newMultipleChoiceLabels.splice(i, 1);
      newMultipleChoiceValues.splice(i, 1);

      this.setState((prevState) => ({
        ...prevState,
        unsavedChanges: true,
        formDatas: {
          ...prevState.formDatas,
          multipleChoiceValues: newMultipleChoiceValues,
          multipleChoiceLabels: newMultipleChoiceLabels,
        },
      }));
    }
  }

  handlePotentiometerLabelChange(event, i) {
    event.preventDefault();
    const newPotentiometerLabels = [
      ...this.state.formDatas.potentiometerLabels,
    ];
    if (i < newPotentiometerLabels.length) {
      newPotentiometerLabels[i] = event.target.value;
      this.setState((prevState) => ({
        ...prevState,
        unsavedChanges: true,
        formDatas: {
          ...prevState.formDatas,
          potentiometerLabels: newPotentiometerLabels,
        },
      }));
    }
  }

  handlePotentiometerValueChange(event, i) {
    event.preventDefault();
    const newPotentiometerValues = [
      ...this.state.formDatas.potentiometerValues,
    ];
    if (
      i < newPotentiometerValues.length &&
      event.target.value >= 0 &&
      event.target.value <= 10
    ) {
      newPotentiometerValues[i] = event.target.value;
      this.setState((prevState) => ({
        ...prevState,
        unsavedChanges: true,
        formDatas: {
          ...prevState.formDatas,
          potentiometerValues: newPotentiometerValues,
        },
      }));
    }
  }

  addPotentiometer(event, i) {
    event.preventDefault();
    const newPotentiometerLabels = [
      ...this.state.formDatas.potentiometerLabels,
    ];
    newPotentiometerLabels.push("");
    const newPotentiometerValues = [
      ...this.state.formDatas.potentiometerValues,
    ];
    newPotentiometerValues.push(0);
    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        potentiometerValues: newPotentiometerValues,
        potentiometerLabels: newPotentiometerLabels,
      },
    }));
  }

  removePotentiometer(event, i) {
    event.preventDefault();
    if (i) {
      const newPotentiometerLabels = [
        ...this.state.formDatas.potentiometerLabels,
      ];
      newPotentiometerLabels.splice(i, 1);
      const newPotentiometerValues = [
        ...this.state.formDatas.potentiometerValues,
      ];
      newPotentiometerValues.splice(i, 1);
      this.setState((prevState) => ({
        ...prevState,
        unsavedChanges: true,
        formDatas: {
          ...prevState.formDatas,
          potentiometerValues: newPotentiometerValues,
          potentiometerLabels: newPotentiometerLabels,
        },
      }));
    }
  }

  vintageImageSelected(event) {
    event.preventDefault();
    const { t } = this.props;

    if (!event.target.files || !event.target.files[0]) {
      return;
    }

    let fileSizeMb = getSizeInMb(event.target.files[0].size);

    if (fileSizeMb > 15) {
      this.setState((prevState) => ({
        ...prevState,
        showVintageImageTooBig: true,
      }));

      return;
    }

    if (
      this.state.formDatas.youtubeVideoUrl ||
      this.state.formDatas.coordsLongitudeArObject ||
      this.state.formDatas.coordsLatitudeArObject ||
      this.state.formDatas.arImageRecognition.imageFile ||
      this.state.formDatas.arImageRecognition.imageUrl ||
      this.state.formDatas.arObject.file ||
      this.state.formDatas.arObject.fileUrl
    ) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newEnigma.error_one_media_only"),
        showSuccess: false,
      }));
      this.state.endOfPageRef.current.scrollIntoView({ behavior: "smooth" });

      return;
    }

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      showVintageImageTooBig: false,
      formDatas: {
        ...prevState.formDatas,
        vintage: {
          ...prevState.formDatas.vintage,
          imageFile: event.target.files[0],
          imageDeleted: false,
        },
      },
    }));
  }

  arImageRecognitionSelected(event) {
    event.preventDefault();
    const { t } = this.props;

    if (!event.target.files || !event.target.files[0]) {
      return;
    }

    let fileSizeMb = getSizeInMb(event.target.files[0].size);

    if (fileSizeMb > 15) {
      this.setState((prevState) => ({
        ...prevState,
        showArRecognitionImageTooBig: true,
      }));

      return;
    }

    if (
      this.state.formDatas.vintage.imageFile ||
      this.state.formDatas.vintage.imageUrl ||
      this.state.formDatas.youtubeVideoUrl
    ) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newEnigma.error_one_media_only"),
        showSuccess: false,
      }));
      this.state.endOfPageRef.current.scrollIntoView({ behavior: "smooth" });

      return;
    }

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      showArRecognitionImageTooBig: false,
      formDatas: {
        ...prevState.formDatas,
        arImageRecognition: {
          ...prevState.formDatas.arImageRecognition,
          imageFile: event.target.files[0],
          imageDeleted: false,
        },
      },
    }));
  }

  clueImageSelected(event) {
    event.preventDefault();

    if (!event.target.files || !event.target.files[0]) {
      return;
    }

    let fileSizeMb = getSizeInMb(event.target.files[0].size);

    if (fileSizeMb > 15) {
      this.setState((prevState) => ({
        ...prevState,
        showClueImageTooBig: true,
      }));

      return;
    }

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      showClueImageTooBig: false,
      formDatas: {
        ...prevState.formDatas,
        clue: {
          ...prevState.formDatas.clue,
          imageFile: event.target.files[0],
          imageDeleted: false,
        },
      },
    }));
  }

  arObjectSelected(event) {
    event.preventDefault();
    const { t } = this.props;

    if (
      this.state.formDatas.vintage.imageFile ||
      this.state.formDatas.vintage.imageUrl ||
      this.state.formDatas.youtubeVideoUrl
    ) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newEnigma.error_one_media_only"),
        showSuccess: false,
      }));
      this.state.endOfPageRef.current.scrollIntoView({ behavior: "smooth" });

      return;
    }

    if (!event.target.files || !event.target.files[0]) {
      return;
    }

    let fileSizeMb = getSizeInMb(event.target.files[0].size);

    if (fileSizeMb > 16) {
      this.setState((prevState) => ({
        ...prevState,
        showArObjectTooBig: true,
      }));

      return;
    }

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      showClueImageTooBig: false,
      formDatas: {
        ...prevState.formDatas,
        arObject: {
          ...prevState.formDatas.clue,
          file: event.target.files[0],
          arObjectDeleted: false,
        },
      },
    }));
  }

  updateTeamPhotoFilter(file) {
    const { t } = this.props;

    if (!file) {
      this.setState((prevState) => ({
        ...prevState,
        unsavedChanges: true,
        formDatas: {
          ...prevState.formDatas,
          teamPhotoFilter: {
            ...prevState.formDatas.teamPhotoFilter,
            imageFile: null,
            fileDeleted: true,
          },
        },
      }));
      return;
    }

    let fileSizeMb = getSizeInMb(file.size);

    if (fileSizeMb > 15) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newEnigma.image_too_big_error"),
        showSuccess: false,
      }));
      this.state.endOfPageRef.current.scrollIntoView({ behavior: "smooth" });
      return;
    }

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        teamPhotoFilter: {
          ...prevState.formDatas.teamPhotoFilter,
          imageFile: file,
          fileDeleted: false,
        },
      },
    }));
  }

  updateSendPhotoWhenGameEnded(event) {
    const value = event.target.checked;

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        sendPhotoWhenGameEnded: value,
      },
    }));
  }

  updateQuizMode(event) {
    const value = event.target.checked;

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        quizMode: value,
      },
    }));
  }

  handleSelectMediaTypeChange(event) {
    event.preventDefault();

    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        mediaType: event.target.value,
        youtubeVideoUrl:
          event.target.value === "youtube"
            ? prevState.formDatas.youtubeVideoUrl
            : null,
        video:
          event.target.value === "video"
            ? prevState.formDatas.video
            : {
              file: null,
              url: null,
              fileName: null,
              fileDeleted:
                !!prevState.formDatas.video?.url || !!prevState.formDatas.video?.file,
            },
      },
    }));
  }

  handleSelectResponseTypeChange(event, value) {
    event.preventDefault();

    let type = EnigmaType.TEXT;
    if (event.target.value == "picker") {
      type = EnigmaType.PICKER;
    } else if (event.target.value == "multipleChoice") {
      type = EnigmaType.MULTIPLE_CHOICE;
    } else if (event.target.value == "recomposeWord") {
      type = EnigmaType.RECOMPOSE_WORD;
    } else if (event.target.value == "compass") {
      type = EnigmaType.COMPASS;
    } else if (event.target.value == "switch") {
      type = EnigmaType.SWITCH;
    } else if (event.target.value == "potentiometer") {
      type = EnigmaType.POTENTIOMETER;
    } else if (event.target.value == "teamPhoto") {
      type = EnigmaType.TEAM_PHOTO;
    }

    this.setState((prevState) => {
      const responseType = event.target.value;

      let nextFormDatas = {
        ...prevState.formDatas,
        unsavedChanges: true,
        responseType: responseType,
        type: type,
      };

      if (responseType === "multipleChoice") {
        const maxChoices = 6;
        const existingLabels = nextFormDatas.multipleChoiceLabels || [];
        const existingValues = nextFormDatas.multipleChoiceValues || [];

        let nextLabels = existingLabels.slice(0, maxChoices);
        let nextValues = existingValues.slice(0, maxChoices);

        // Contraintes UI: au minimum 2 choix pour "multipleChoice"
        while (nextLabels.length < 2) nextLabels.push("");
        while (nextValues.length < 2) nextValues.push(false);

        nextFormDatas = {
          ...nextFormDatas,
          multipleChoiceLabels: nextLabels,
          multipleChoiceValues: nextValues,
        };
      }

      if (responseType === "recomposeWord") {
        nextFormDatas = {
          ...nextFormDatas,
          recomposeWordTarget:
            typeof nextFormDatas.recomposeWordTarget === "string"
              ? nextFormDatas.recomposeWordTarget
              : "",
          recomposeRandomLettersEnabled:
            !!nextFormDatas.recomposeRandomLettersEnabled,
          recomposeRandomLettersCount:
            typeof nextFormDatas.recomposeRandomLettersCount === "number"
              ? nextFormDatas.recomposeRandomLettersCount
              : 0,
        };
      }

      return { formDatas: nextFormDatas };
    });
  }

  sanitizeRecomposeWord(value) {
    if (typeof value !== "string") return "";
    // Autorise lettres (accents), chiffres et espaces, supprime le reste
    const cleaned = value.replace(/[^\p{L}\p{N} ]/gu, "");
    return cleaned.substring(0, 12);
  }

  getRecomposeRandomLettersMax(word) {
    const length = typeof word === "string" ? word.length : 0;
    return Math.max(0, 18 - length);
  }

  updateRecomposeWordTarget(event) {
    event.preventDefault();
    const nextWord = this.sanitizeRecomposeWord(event.target.value);

    this.setState((prevState) => {
      const enabled = !!prevState.formDatas.recomposeRandomLettersEnabled;
      const max = this.getRecomposeRandomLettersMax(nextWord);
      const currentCount =
        typeof prevState.formDatas.recomposeRandomLettersCount === "number"
          ? prevState.formDatas.recomposeRandomLettersCount
          : 0;

      let nextCount = currentCount;
      if (enabled) {
        if (nextCount > max) nextCount = max;
        if (nextCount < 1) nextCount = 1;
      } else {
        nextCount = 0;
      }

      return {
        ...prevState,
        unsavedChanges: true,
        formDatas: {
          ...prevState.formDatas,
          recomposeWordTarget: nextWord,
          recomposeRandomLettersCount: nextCount,
        },
      };
    });
  }

  updateRecomposeRandomLettersEnabled(event) {
    const enabled = !!event.target.checked;
    this.setState((prevState) => {
      const word = prevState.formDatas.recomposeWordTarget || "";
      const max = this.getRecomposeRandomLettersMax(word);
      const currentCount =
        typeof prevState.formDatas.recomposeRandomLettersCount === "number"
          ? prevState.formDatas.recomposeRandomLettersCount
          : 0;

      let nextCount = enabled ? currentCount : 0;
      if (enabled) {
        if (nextCount < 1) nextCount = 1;
        if (nextCount > max) nextCount = max;
      }

      return {
        ...prevState,
        unsavedChanges: true,
        formDatas: {
          ...prevState.formDatas,
          recomposeRandomLettersEnabled: enabled,
          recomposeRandomLettersCount: nextCount,
        },
      };
    });
  }

  updateRecomposeRandomLettersCount(event) {
    event.preventDefault();
    const raw = event.target.value;
    let nextValue = parseInt(raw, 10);
    if (isNaN(nextValue)) nextValue = 0;

    this.setState((prevState) => {
      const enabled = !!prevState.formDatas.recomposeRandomLettersEnabled;
      const word = prevState.formDatas.recomposeWordTarget || "";
      const max = this.getRecomposeRandomLettersMax(word);

      if (!enabled) {
        return {
          ...prevState,
          unsavedChanges: true,
          formDatas: {
            ...prevState.formDatas,
            recomposeRandomLettersCount: 0,
          },
        };
      }

      if (nextValue < 1) nextValue = 1;
      if (nextValue > max) nextValue = max;

      return {
        ...prevState,
        unsavedChanges: true,
        formDatas: {
          ...prevState.formDatas,
          recomposeRandomLettersCount: nextValue,
        },
      };
    });
  }

  deleteImage(deleteClueImage, deleteVintageImage, deleteArRecognitionImage) {
    if (deleteClueImage) {
      this.setState((prevState) => ({
        ...prevState,
        unsavedChanges: true,
        formDatas: {
          ...prevState.formDatas,
          clue: {
            ...prevState.formDatas.clue,
            imageFile: null,
            imageUrl: null,
            imageDeleted: true,
          },
        },
      }));
    }
    if (deleteVintageImage) {
      this.setState((prevState) => ({
        ...prevState,
        unsavedChanges: true,
        formDatas: {
          ...prevState.formDatas,
          vintage: {
            ...prevState.formDatas.vintage,
            imageFile: null,
            imageUrl: null,
            imageDeleted: true,
          },
        },
      }));
    }
    if (deleteArRecognitionImage) {
      this.setState((prevState) => ({
        ...prevState,
        unsavedChanges: true,
        formDatas: {
          ...prevState.formDatas,
          arImageRecognition: {
            ...prevState.formDatas.arImageRecognition,
            imageFile: null,
            imageUrl: null,
            imageDeleted: true,
          },
        },
      }));
    }
  }

  deleteObjFile() {
    this.setState((prevState) => ({
      ...prevState,
      unsavedChanges: true,
      formDatas: {
        ...prevState.formDatas,
        arObject: {
          ...prevState.formDatas.clue,
          imageFile: null,
          imageUrl: null,
          fileName: null,
          arObjectDeleted: true,
        },
      },
    }));
  }

  isResponsePickerValid() {
    var i = 0;
    for (let response of this.state.formDatas.responsesPicker) {
      var foundResponse = false;
      for (let choice of this.state.formDatas.pickerChoices[i].value.split(
        ";"
      )) {
        if (choice === response) {
          foundResponse = true;
        }
      }
      if (!foundResponse) {
        return false;
      }
      i++;
    }
    return true;
  }

  async submitForm(event) {
    event.preventDefault();
    const { t } = this.props;

    if (this.state.role === "NO_SUBSCRIBTION" || this.state.tourDisabled) {
      return;
    }

    var serverResp = null;

    if (this.state.formDatas.responseType === "picker") {
      let isValid = this.isResponsePickerValid();
      if (!isValid) {
        this.setState((prevState) => ({
          ...prevState,
          showError: true,
          errorMessage: t("newEnigma.error_missing_response_propositions"),
          showSuccess: false,
        }));
        return;
      }
    }

    if (this.state.formDatas.responseType === "multipleChoice") {
      const labels = this.state.formDatas.multipleChoiceLabels || [];
      const isValid =
        labels.length >= 2 &&
        labels.every(
          (label) => typeof label === "string" && label.trim() !== ""
        );

      if (!isValid) {
        this.setState((prevState) => ({
          ...prevState,
          showError: true,
          errorMessage: t(
            "newEnigma.error_missing_multiple_choice_options"
          ),
          showSuccess: false,
        }));
        return;
      }
    }

    if (this.state.formDatas.responseType === "recomposeWord") {
      const word = (this.state.formDatas.recomposeWordTarget || "").toString();
      const wordLength = word.length;
      if (wordLength < 3 || wordLength > 12) {
        this.setState((prevState) => ({
          ...prevState,
          showError: true,
          errorMessage: t("newEnigma.error_recompose_word_length"),
          showSuccess: false,
        }));
        return;
      }

      if (this.state.formDatas.recomposeRandomLettersEnabled) {
        const max = this.getRecomposeRandomLettersMax(word);
        const count =
          typeof this.state.formDatas.recomposeRandomLettersCount === "number"
            ? this.state.formDatas.recomposeRandomLettersCount
            : 0;
        if (count < 1 || count > max) {
          this.setState((prevState) => ({
            ...prevState,
            showError: true,
            errorMessage: t("newEnigma.error_recompose_random_letters_count"),
            showSuccess: false,
          }));
          return;
        }
      }
    }
    if (
      (this.state.formDatas.arImageRecognition.imageFile ||
        this.state.formDatas.arImageRecognition.imageUrl) &&
      !this.state.formDatas.arObject.file &&
      !this.state.formDatas.arObject.fileUrl
    ) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newEnigma.error_missing_ar_object"),
        showSuccess: false,
      }));
      return;
    }
    if (
      (this.state.formDatas.coordsLongitudeArObject ||
        this.state.formDatas.coordsLatitudeArObject) &&
      !this.state.formDatas.arObject?.file &&
      !this.state.formDatas.arObject?.fileUrl
    ) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newEnigma.error_ar_object_location_missing"),
        showSuccess: false,
      }));
      return;
    }
    if (
      (this.state.formDatas.coordsLongitudeArObject &&
        !this.state.formDatas.coordsLatitudeArObject) ||
      (!this.state.formDatas.coordsLongitudeArObject &&
        this.state.formDatas.coordsLatitudeArObject)
    ) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newEnigma.error_coordinates_incomplete"),
        showSuccess: false,
      }));
      return;
    }

    this.setState((prevState) => ({
      ...prevState,
      loadingViewOpened: true,
    }));

    let formDatasToSend = this.state.formDatas;
    if (this.state.formDatas.responseType === "multipleChoice") {
      const labels = this.state.formDatas.multipleChoiceLabels || [];
      const multipleChoiceValues =
        this.state.formDatas.multipleChoiceValues || [];
      formDatasToSend = {
        ...this.state.formDatas,
        multipleChoiceValues: labels.map((_, idx) =>
          idx < multipleChoiceValues.length ? !!multipleChoiceValues[idx] : false
        ),
      };
    }

    if (this.state.formDatas.responseType === "recomposeWord") {
      formDatasToSend = {
        ...formDatasToSend,
        recomposeWordTarget: (this.state.formDatas.recomposeWordTarget || "")
          .toString()
          .substring(0, 12),
        recomposeRandomLettersEnabled:
          !!this.state.formDatas.recomposeRandomLettersEnabled,
        recomposeRandomLettersCount: this.state.formDatas
          .recomposeRandomLettersEnabled
          ? typeof this.state.formDatas.recomposeRandomLettersCount === "number"
            ? this.state.formDatas.recomposeRandomLettersCount
            : 0
          : 0,
      };
    }

    if (this.state.editing) {
      const formDatas = formDatasToSend;

      if (this.state.formDatas.mediaType === "none") {
        this.deleteImage(false, true, true);
        this.setState((prevState) => ({
          ...prevState,
          formDatas: {
            ...prevState.formDatas,
            youtubeVideoUrl: null,
            video: {
              file: null,
              url: null,
              fileName: null,
              fileDeleted:
                !!prevState.formDatas.video?.url || !!prevState.formDatas.video?.file,
            },
          },
        }));
        formDatas.arImageRecognition = {
          title: "",
          imageFile: null,
          imageUrl: null,
          imageDeleted: true,
        };
        formDatas.vintage = {
          title: "",
          imageFile: null,
          imageUrl: null,
          imageDeleted: true,
        };
        formDatas.arObject = {
          file: null,
          fileUrl: null,
          arObjectDeleted: true,
          arImageRecognitionDeleted: true,
        };
        formDatas.youtubeVideoUrl = null;
        formDatas.video = {
          file: null,
          url: null,
          fileName: null,
          fileDeleted: true,
        };
      }
      serverResp = await ApiEnigma.updateEnigma(
        formDatas,
        this.state.formDatas.enigmaId
      );
    } else {
      serverResp = await ApiEnigma.uploadEnigma(formDatasToSend);
    }

    this.setState((prevState) => ({
      ...prevState,
      loadingViewOpened: false,
    }));
    if (serverResp.status != 201 && serverResp.status != 200) {
      if (serverResp.status === 403) {
        this.setState((prevState) => ({
          ...prevState,
          showError: true,
          errorMessage: t("newEnigma.error_max_enigma"),
          showSuccess: false,
        }));
        return;
      }
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newEnigma.error_server_communication"),
        showSuccess: false,
      }));

      return;
    } else {
      this.getAccount();
      this.setState((prevState) => {
        const newState = {
          ...prevState,
          showSuccess: true,
          unsavedChanges: false,
          editing: true,
          showError: false,
          errorMessage: "",
          successMessage: t("newEnigma.success_enigma_saved"),
          formDatas: {
            ...prevState.formDatas,
            enigmaId: serverResp.data.enigmaId,
            uuid: serverResp.data.uuid,
            enigmaText:
              serverResp.data.enigmaText || prevState.formDatas.enigmaText,
          },
        };
        return newState;
      });

      window.dispatchEvent(
        new CustomEvent("tourHierarchy:refreshEnigmas", {
          detail: { zoneId: this.state.formDatas.zoneId },
        })
      );
    }
  }

  isImageSet(localUrl, signedUrl) {
    if (ImageUtils.getImageUrlFromFile(localUrl)) {
      return true;
    } else if (ImageUtils.getImageUrlFromFile(signedUrl)) {
      return true;
    }
    return false;
  }

  resetErrorAlert() {
    this.setState((prevState) => ({
      ...prevState,
      showError: false,
      errorMessage: "",
    }));
  }

  resetSuccessAlert() {
    this.setState((prevState) => ({
      ...prevState,
      showSuccess: false,
      successMessage: "",
    }));
  }

  getLanguageName(language) {
    console.log("language code", language);
    let ln = language.split("-")[0];
    console.log("language split", ln);
    const languageNames = {
      fr: "Français",
      en: "Anglais",
      es: "Espagnol",
      de: "Allemand",
      it: "Italien",
      nl: "Néerlandais",
      pl: "Polonais",
      pt: "Portugais",
      ro: "Roumain",
      ru: "Russe",
      ja: "Japonais",
      zh: "Chinois",
      ar: "Arabe",
      hi: "Hindi",
      tr: "Turc",
      vi: "Vietnamien",
    };
    return languageNames[ln] || language;
  }

  handleGenerateEnigma = async () => {
    const { t, i18n } = this.props;
    console.log("this.state.formDatas", this.state.formDatas);
    const language = this.getLanguageName(i18n.language);

    if (!this.state.textPrompt) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("newEnigma.error_enter_text_to_generate"),
        showSuccess: false,
      }));
      this.handleCloseAIModal();
      return;
    }
    this.setState({ loading: true });

    try {
      const response = await ApiEnigma.generateEnigmaWithAI(
        this.state.textPrompt,
        this.state.generateImage,
        language,
        this.state.formDatas.enigmaId
      );

      if (response.status === 200) {
        const { enigmaText, enigmaResponse, enigmaChoices } = response.data;
        const enigmaType = EnigmaType.PICKER;
        this.setState(
          (prevState) => ({
            ...prevState,
            unsavedChanges: true,
            showSuccess: this.state.generateImage ? false : true,
            successMessage: this.state.generateImage
              ? ""
              : "L'énigme a été générée",
            loading: this.state.generateImage ? true : false,
            enigmaLoaded: false,
            formDatas: {
              ...prevState.formDatas,
              title: enigmaText,
              pickerChoices: null,
              responseType: "picker",
              type: enigmaType,
            },
          }),
          () => {
            const pickerResponses = {
              target: {
                value: enigmaResponse,
                id: 0,
              },
            };
            const pickerChoices = {
              target: {
                value: enigmaChoices,
                id: "picker-response-0",
              },
            };
            this.handleResponsesPickerTextChange(pickerResponses, () => {
              this.updatePickerChoice(pickerChoices, 0);
            });
            this.setState((prevState) => ({
              ...prevState,
              enigmaLoaded: true,
            }));
            if (this.state.generateImage) {
              this.setState(
                (prevState) => ({
                  ...prevState,
                  imagePrompt:
                    "Génère une image en accord avec l'énigme sachant que ma demande initiale pour la création de l'énigme était : " +
                    this.state.formDatas.enigmaText,
                }),
                () => {
                  this.handleGenerateAIImage(true);
                }
              );

              return;
            }
          }
        );
        if (!this.state.generateImage) {
          this.handleCloseAIModal();
        }
      } else if (response.status === 400) {
        this.setState({
          showError: true,
          errorMessage: t("newEnigma.error_not_enough_credits"),
          showSuccess: false,
        });
        this.handleCloseAIModal();
      } else {
        this.setState({
          showError: true,
          errorMessage: t("newEnigma.generate_with_ai.generation_error"),
          loading: false,
        });
        this.handleCloseAIModal();
      }
    } catch (error) {
      console.log("error", error);
      this.setState({
        showError: true,
        errorMessage: t("newEnigma.generate_with_ai.generation_error"),
        loading: false,
      });
      this.handleCloseAIModal();
    }
  };

  handleOpenAIModal = () => {
    this.setState({ openAIModal: true });
  };

  handleCloseAIModal = () => {
    this.setState({
      openAIModal: false,
      generateImage: false,
    });
  };

  handleOpenAIImageModal = () => {
    this.setState({ openAIImageModal: true });
  };

  handleCloseAIImageModal = () => {
    this.setState({ openAIImageModal: false });
  };

  handleGenerateImageChange = (event) => {
    this.setState({ generateImage: event.target.checked });
  };

  handlePromptChange = (event) => {
    this.setState({ textPrompt: event.target.value });
  };

  handleImagePromptChange = (event) => {
    this.setState({ imagePrompt: event.target.value });
  };

  handleGenerateAIImage = async (generationAfterEnigmaGeneration = false) => {
    this.setState({ loading: true });
    const { t } = this.props;

    if (!this.state.imagePrompt) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: "Veuillez entrer un texte pour générer l'image",
        showSuccess: false,
        loading: false,
      }));
      this.handleCloseAIImageModal();
      return;
    }

    try {
      const apiResponse = await ApiEnigma.generateEnigmaImageWithAI(
        this.state.imagePrompt,
        this.state.formDatas.title,
        this.state.formDatas.enigmaId
      );

      if (apiResponse.status === 200) {
        // Ici, apiResponse.data est un ArrayBuffer
        const arrayBuffer = apiResponse.data;

        // Création d'un Blob à partir de l'ArrayBuffer
        const blob = new Blob([arrayBuffer], { type: "image/jpeg" });

        // Optionnel : Créer une URL pour afficher un aperçu de l'image
        const imageUrl = URL.createObjectURL(blob);
        console.log("URL de l'image générée:", imageUrl);

        // Générer un nom de fichier unique
        const timestamp = new Date().getTime();
        const randomId = Math.random().toString(36).substring(2, 8);
        const fileName = `ai-generated-${timestamp}-${randomId}.jpeg`;

        const imageFile = new File([blob], fileName, { type: "image/jpeg" });

        this.setState((prevState) => ({
          ...prevState,
          imagePrompt: generationAfterEnigmaGeneration
            ? ""
            : this.state.imagePrompt,
          formDatas: {
            ...prevState.formDatas,
            mediaType: "image",
            vintage: {
              ...prevState.formDatas.vintage,
              imageFile: imageFile,
              imageUrl: imageUrl,
            },
          },
          showSuccess: true,
          successMessage: generationAfterEnigmaGeneration
            ? "Le texte et l'image ont été générés"
            : "Image générée avec succès",
          showError: false,
        }));
      } else if (apiResponse.status === 400) {
        this.setState({
          showError: true,
          errorMessage: t("newEnigma.error_not_enough_credits"),
          showSuccess: false,
        });
      } else {
        console.log("apiResponse.status", apiResponse.status);
        console.log("apiResponse.data", apiResponse.data);
        this.setState({
          showError: true,
          errorMessage: "Error",
          showSuccess: false,
        });
      }
    } catch (error) {
      console.error("Error", error);
      this.setState({
        showError: true,
        errorMessage: "Error",
        showSuccess: false,
      });
    } finally {
      this.getAccount();
      this.setState({ loading: false });
      if (!generationAfterEnigmaGeneration) {
        this.handleCloseAIImageModal();
      } else {
        this.handleCloseAIModal();
      }
    }
  };

  render() {
    return (
      <>
        <NewEnigmaView
          {...this.props}
          state={this.state}
          formDatas={this.state.formDatas}
          setSelectedTab={this.setSelectedTab}
          setSelectedTabClue={this.setSelectedTabClue}
          updateTitle={this.updateTitle}
          updateEnigmaText={this.updateEnigmaText}
          updatePoints={this.updatePoints}
          handleSelectResponseTypeChange={this.handleSelectResponseTypeChange}
          handleSelectMediaTypeChange={this.handleSelectMediaTypeChange}
          updateResponsesText={this.updateResponsesText}
          handleResponsesPickerTextChange={this.handleResponsesPickerTextChange}
          updatePickerChoice={this.updatePickerChoice}
          updateFinishText={this.updateFinishText}
          updateShowFinishOnLoose={this.updateShowFinishOnLoose}
          updateClueTitle={this.updateClueTitle}
          updateYoutubeVideoUrl={this.updateYoutubeVideoUrl}
          clueImageSelected={this.clueImageSelected}
          deleteImage={this.deleteImage}
          updateClueTime={this.updateClueTime}
          updateVintageTitle={this.updateVintageTitle}
          vintageImageSelected={this.vintageImageSelected}
          videoSelected={this.videoSelected}
          deleteVideo={this.deleteVideo}
          submitForm={this.submitForm}
          isImageSet={this.isImageSet}
          handleResponsesCompassChange={this.handleResponsesCompassChange}
          handleSwitchLabelChange={this.handleSwitchLabelChange}
          handleSwitchValueChange={this.handleSwitchValueChange}
          addSwitch={this.addSwitch}
          addMultipleChoice={this.addMultipleChoice}
          removeSwitch={this.removeSwitch}
          handleMultipleChoiceLabelChange={
            this.handleMultipleChoiceLabelChange
          }
          handleMultipleChoiceValueChange={
            this.handleMultipleChoiceValueChange
          }
          removeMultipleChoice={this.removeMultipleChoice}
          updateRecomposeWordTarget={this.updateRecomposeWordTarget}
          updateRecomposeRandomLettersEnabled={
            this.updateRecomposeRandomLettersEnabled
          }
          updateRecomposeRandomLettersCount={this.updateRecomposeRandomLettersCount}
          handlePotentiometerLabelChange={this.handlePotentiometerLabelChange}
          handlePotentiometerValueChange={this.handlePotentiometerValueChange}
          addPotentiometer={this.addPotentiometer}
          removePotentiometer={this.removePotentiometer}
          showLatOnMap={this.state.showLatOnMap}
          showLngOnMap={this.state.showLngOnMap}
          mapDialogOpen={this.state.mapDialogOpen}
          closeMapDialog={this.closeMapDialog}
          openMapDialog={this.openMapDialog}
          setArObjectLocation={this.setArObjectLocation}
          deleteObjFile={this.deleteObjFile}
          arObjectSelected={this.arObjectSelected}
          arImageRecognitionSelected={this.arImageRecognitionSelected}
          updateArCoordsLatitude={this.updateArCoordsLatitude}
          updateArCoordsLongitude={this.updateArCoordsLongitude}
          hasOtherMediaThanYT={this.hasOtherMediaThanYT}
          updateTeamPhotoFilter={this.updateTeamPhotoFilter}
          updateSendPhotoWhenGameEnded={this.updateSendPhotoWhenGameEnded}
          updateQuizMode={this.updateQuizMode}
          resetErrorAlert={this.resetErrorAlert}
          resetSuccessAlert={this.resetSuccessAlert}
          handleGenerateEnigma={this.handleGenerateEnigma}
          handleOpenAIModal={this.handleOpenAIModal}
          handleCloseAIModal={this.handleCloseAIModal}
          handleOpenAIImageModal={this.handleOpenAIImageModal}
          handleCloseAIImageModal={this.handleCloseAIImageModal}
          handleGenerateImageChange={this.handleGenerateImageChange}
          handlePromptChange={this.handlePromptChange}
          handleImagePromptChange={this.handleImagePromptChange}
          handleGenerateAIImage={this.handleGenerateAIImage}
        />
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  withTranslation()(NewEnigma)
);
